///////COMPONENTS///////
import { put, select, takeLatest } from 'redux-saga/effects'
import ActionsTypes from '../../constants/ActionsTypes'
import { globalLoadingActionCreators, errorManagerActionCreators, scheduledPromoManagerActionCreators } from '../actions'
import * as R from '../../constants/Endpoint'
import { API_TOKEN } from '../../config/AxiosConfig'
import { selectIdsUser } from '../selectors/user'

const getScheduledPromo = function* ({ payload }) {
	const bodyMsg = payload.filters
	const user = yield select(selectIdsUser)
	const apiCall = R.GET_SCHEDULED_PROMO(payload.queryParams)

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).post(apiCall, bodyMsg)

		yield put(scheduledPromoManagerActionCreators.getScheduledPromoSuccess(data.data, payload.idPromo, payload.toggledLines))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(scheduledPromoManagerActionCreators.getScheduledPromoFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}
const getScheduledPromoUnit = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.GET_CAMPAIGN_PROMO(payload.idPromo)

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).get(apiCall)

		yield put(scheduledPromoManagerActionCreators.getScheduledPromoUnitSuccess(data.data))
	} catch (e) {
		if (e.response?.status !== 400) {
			yield put(errorManagerActionCreators.createError(e.response))
		} // guard to layout modal error on managed error

		yield put(scheduledPromoManagerActionCreators.getScheduledPromoUnitFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const getTransmissionPromo = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.GET_TRANSMISSION_PROMO(payload.idCampaign)

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).get(apiCall)

		yield put(scheduledPromoManagerActionCreators.getTransmissionPromoSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(scheduledPromoManagerActionCreators.getTransmissionPromoFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const getPromoCampaignNestedLines = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.GET_PROMO_CAMPAIGN_NESTED_LINES(payload.idCampaign, payload.withTtc)
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).get(apiCall)

		yield put(scheduledPromoManagerActionCreators.getPromoCampaignNestedLinesSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(scheduledPromoManagerActionCreators.getPromoCampaignNestedLinesFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const sagas = function* () {
	yield takeLatest(ActionsTypes.GET_SCHEDULED_PROMO, getScheduledPromo)
	yield takeLatest(ActionsTypes.GET_SCHEDULED_PROMO_UNIT, getScheduledPromoUnit)
	yield takeLatest(ActionsTypes.GET_TRANSMISSION_PROMO, getTransmissionPromo)
	yield takeLatest(ActionsTypes.GET_PROMO_CAMPAIGN_NESTED_LINES, getPromoCampaignNestedLines)
}

export default sagas
